"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeColorApi = changeColorApi;
exports.clearCacheApi = clearCacheApi;
exports.configCheckUnique = configCheckUnique;
exports.configDelete = configDelete;
exports.configGetUniq = configGetUniq;
exports.configInfo = configInfo;
exports.configList = configList;
exports.configSave = configSave;
exports.configSaveForm = configSaveForm;
exports.configSaveUniq = configSaveUniq;
exports.configUpdate = configUpdate;
exports.frontDomainApi = frontDomainApi;
exports.getAuthHostApi = getAuthHostApi;
exports.getHomeStyleApi = getHomeStyleApi;
exports.getMiniDownloadUrlApi = getMiniDownloadUrlApi;
exports.getSiteLogoApi = getSiteLogoApi;
exports.getTxMapKeyApi = getTxMapKeyApi;
exports.mediaDomainApi = mediaDomainApi;
exports.passAppInfoApi = passAppInfoApi;
exports.passAppSaveApi = passAppSaveApi;
exports.saveColorApi = saveColorApi;
exports.savehomeStyleApi = savehomeStyleApi;
exports.systemStateInfoApi = systemStateInfoApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

function configCheckUnique(pram) {
  var data = {
    name: pram.name
  };
  return (0, _request.default)({
    url: '/admin/system/config/check',
    method: 'GET',
    params: data
  });
}
function configDelete(pram) {
  var data = {
    id: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/config/delete',
    method: 'GET',
    params: data
  });
}
function configInfo(pram) {
  var data = {
    formId: pram.id
  };
  return (0, _request.default)({
    url: '/admin/system/config/info',
    method: 'GET',
    params: data
  });
}
function configList(pram) {
  var data = {
    page: pram.page,
    limit: pram.limit
  };
  return (0, _request.default)({
    url: '/admin/system/config/list',
    method: 'GET',
    params: data
  });
}
function configSave(pram) {
  var data = {
    systemConfigRequest: {
      desc: pram.desc,
      groupId: pram.groupId,
      info: pram.info,
      name: pram.name,
      pid: pram.pid,
      status: pram.status,
      type: pram.type,
      value: pram.value // value 存储表单配置数据，其他的参数来自于父级数据 justForAPI
    }
  };
  return (0, _request.default)({
    url: '/admin/system/config/save',
    method: 'POST',
    params: data
  });
}
function configSaveForm(pram) {
  return (0, _request.default)({
    url: '/admin/system/config/save/form',
    method: 'POST',
    data: pram
  });
}
function configUpdate(pram) {
  var data = {
    id: pram.id,
    systemConfigRequest: pram.systemConfigRequest
  };
  return (0, _request.default)({
    url: '/admin/system/config/update',
    method: 'POST',
    params: data
  });
}
function configSaveUniq(pram) {
  var data = {
    key: pram.key,
    value: pram.value
  };
  return (0, _request.default)({
    url: '/admin/system/config/saveuniq',
    method: 'POST',
    params: data
  });
}
function configGetUniq(pram) {
  var data = {
    key: pram.key
  };
  return (0, _request.default)({
    url: '/admin/system/config/getuniq',
    method: 'GET',
    params: data
  });
}

/**
 * @description 获取管理端logo
 */
function getSiteLogoApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/site/logo',
    method: 'GET'
  });
}

/**
}

/**
 * @description 获取小程序下载地址
 */
function getMiniDownloadUrlApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/mini/download/url',
    method: 'GET'
  });
}

/**
 * @description 获取腾讯地图key
 */
function getTxMapKeyApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/tx/map/key',
    method: 'GET'
  });
}

/**
 * @description 获取移动端首页列表样式
 */
function getHomeStyleApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/home/page/list/style',
    method: 'GET'
  });
}

/**
 * @description 获取移动端首页列表样式
 */
function getAuthHostApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/auth/host',
    method: 'GET'
  });
}

/**
 * @description 清除config缓存
 */
function clearCacheApi() {
  return (0, _request.default)({
    url: '/admin/system/config/clear/cache',
    method: 'post'
  });
}

/**
 * @description 获取主题色
 */
function changeColorApi() {
  return (0, _request.default)({
    url: '/admin/system/config/get/change/color',
    method: 'get'
  });
}

/**
 * @description 保存主题色
 */
function saveColorApi(data) {
  return (0, _request.default)({
    url: '/admin/system/config/save/change/color',
    method: 'post',
    data: data
  });
}

/**
 * @description 保存移动端首页列表样式
 */
function savehomeStyleApi(data) {
  return (0, _request.default)({
    url: '/admin/system/config/save/home/page/list/style',
    method: 'post',
    data: data
  });
}

/**
 * @description 一号通 应用保存
 */
function passAppSaveApi(data) {
  return (0, _request.default)({
    url: '/admin/pass/appsave',
    method: 'post',
    data: data
  });
}

/**
 * @description 一号通 应用详情获取
 */
function passAppInfoApi() {
  return (0, _request.default)({
    url: '/admin/pass/appget',
    method: 'get'
  });
}
/**
 * @description 获取移动端域名
 */
function frontDomainApi(data) {
  return (0, _request.default)({
    url: '/public/jsconfig/get/front/domain',
    method: 'GET'
  });
}
/**
 * @description 获取图片域名
 */
function mediaDomainApi(data) {
  return (0, _request.default)({
    url: '/public/jsconfig/get/admin/mediadomain',
    method: 'GET'
  });
}
/**
 * @description 获取系统状态信息
 */
function systemStateInfoApi() {
  return (0, _request.default)({
    url: '/admin/system/status/info',
    method: 'get'
  });
}